module.exports = __webpack_public_path__ + "img/icon-bennett.ae125818.webp";